<div *ngFor="let voucher of voucher$ | async">
  <div
    *ngIf="voucher?.valid"
    class="mb-3 px-5 lg:px-0 max-w-md lg:max-w-full mx-auto"
  >
    <app-discount-voucher-atom
      [voucher]="voucher.name ?? voucher.code"
      [isValid]="voucher.valid"
    ></app-discount-voucher-atom>
  </div>
</div>
